<template>
  <label
    class="d-flex flex-wrap column-gap-1 align-items-center form-label form-label-sm"
    :for="forAttr"
    :class="{
      'w-100': hasAction,
    }"
  >
    <span v-if="label && required" class="text-danger me-1">*</span>
    <span v-if="label">{{ label }}</span>
    <span v-if="textOfError" class="text-danger error-label">- {{ textOfError }}</span>
    <span v-if="textOfSuccess" class="text-success error-label">- {{ textOfSuccess }}</span>

    <slot name="action"></slot>
  </label>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  for: {
    type: String,
    default: '',
  },
  field: {
    type: String,
    default: '',
  },
  errors: {
    type: [Object, String],
    default: () => ({}),
  },
  success: {
    type: [Object, String],
    default: () => ({}),
  },
  required: {
    type: Boolean,
    default: false,
  },
  hasAction: {
    type: Boolean,
    default: false,
  },
});

const forAttr = computed(() => props.for);
const textOfError = computed(() => {
  if (!props.errors) {
    return '';
  }
  if (typeof props.errors === 'string') {
    return props.errors;
  }
  return deepGet(props.errors, props.field.split('.'), '');
});
const textOfSuccess = computed(() => {
  if (!props.success) {
    return '';
  }
  if (typeof success === 'string') {
    return props.success;
  }

  return deepGet(props.success, props.field.split('.'), '');
});

const deepGet = (obj, props, defaultValue) => {
  if (obj === undefined || obj === null) {
    return defaultValue;
  }
  if (props.length === 0) {
    return obj;
  }

  const foundSoFar = obj[props[0]];
  const remainingProps = props.slice(1);

  return deepGet(foundSoFar, remainingProps, defaultValue);
}
</script>
